type AppConfig = {
    ENV: string;
    VERSION: string;
    DEBUG: boolean;
    MOCK: boolean;
    BACKEND: 'yii' | 'laravel';
    APP_NAME: string;
    APP_URL: string;
    API_URL: string;
    BUGSNAG_KEY: string;
    SENTRY_DSN: string;
    GOOGLE_MAPS_KEY: string;
    AUTH_KEY: string;
    LOCALSTORAGE_EXPIRES_KEY: string;
    LOCALSTORAGE_EXPIRES_TIME: number;
    LOCALSTORAGE_LOGIN_KEY: string;
    SESSION_ABSOLUTE_TIMEOUT_HOURS: number;
    /**
     * Go-live date of the new features, as YYYY-MM-DD. Drives the 10-day
     * "what's new" banner on the Dashboard. Empty means no release date has
     * been configured, and the banner stays hidden.
     */
    FEATURE_RELEASE_DATE: string;
};

// Shared text field character limits
export const MAX_LONG_TEXT_LENGTH = 300;
export const MAX_SHORT_TEXT_LENGTH = 50;

// .env constants
const {
    REACT_APP_ENV,
    REACT_APP_VERSION,

    REACT_APP_APP_NAME,
    REACT_APP_URL,
    REACT_APP_API_URL,

    REACT_APP_BUGSNAG_KEY,
    REACT_APP_SENTRY_DSN,
    REACT_APP_GOOGLE_MAPS_KEY,
    REACT_APP_FEATURE_RELEASE_DATE,
} = process.env;

// APP CONSTANTS
const app:AppConfig = {
    ENV: REACT_APP_ENV || 'local',
    VERSION: REACT_APP_VERSION || '0.0.0',
    DEBUG: REACT_APP_ENV === 'local',
    MOCK: false,
    BACKEND: 'yii', // or 'laravel'

    APP_NAME: REACT_APP_APP_NAME || 'Scorchsoft React Boilerplate',

    APP_URL: REACT_APP_URL || 'http://localhost:3000',
    API_URL: REACT_APP_API_URL || 'http://localhost:3000/api',

    BUGSNAG_KEY: REACT_APP_BUGSNAG_KEY || '',
    SENTRY_DSN: REACT_APP_SENTRY_DSN || 'https://21399070a00e85f3354a09cd1606cb09@o4510664450310144.ingest.de.sentry.io/4511372556370000',
    GOOGLE_MAPS_KEY: REACT_APP_GOOGLE_MAPS_KEY || '',

    // Deliberately no fallback date. A wrong hard-coded date would silently run
    // the announcement over the wrong ten days; an empty one just means no
    // banner, which is the safe way to be misconfigured.
    FEATURE_RELEASE_DATE: REACT_APP_FEATURE_RELEASE_DATE || '',

    AUTH_KEY: 'auth-key',
    // Idle (inactivity) anchor: timestamp of the last user-initiated activity.
    LOCALSTORAGE_EXPIRES_KEY: 'session-token-expiry',
    LOCALSTORAGE_EXPIRES_TIME: 360, // idle timeout, minutes (6 hours)
    // Absolute anchor: timestamp of login. The session is capped at
    // SESSION_ABSOLUTE_TIMEOUT_HOURS since login regardless of activity.
    LOCALSTORAGE_LOGIN_KEY: 'session-login-time',
    SESSION_ABSOLUTE_TIMEOUT_HOURS: 24,
};

export default app;
